import classnames from "classnames";
import { useEffect, useState } from 'react';
import { Space, Input, Button, Pagination, Table, Popconfirm, message } from 'antd';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { userCource, courseDelete } from '@/apis/course';
import intl from "react-intl-universal";
const MyCourse = () => {
	const [params, setParams] = useState({
		currentPage: 1,
		pageSize: 10
	})
	const [keywords, setKeywords] = useState('');
	const [total, setTotal] = useState(100)
	const navigate = useNavigate()
	const [data, setData] = useState([])
	const getList = () => {
		userCource({
			...params,
			keywords: keywords,
		}).then(res => {
			setData(res.data.records)
			setTotal(res.data.total)
		})
	}
	useEffect(() => {
		getList()
	}, [params])
	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			setParams({
				...params,
				currentPage: 1
			})
		}
	}

	const deleteRecord = (id) => {
		courseDelete({
			courseUuid: id
		}).then(res => {
			message.success("删除成功")
			getList()
		})
	}

	const linkTo = (id) => {
		if (id) {
			navigate(`/discover/course-add-edit?id=${id}`)
		} else {
			navigate('/discover/course-add-edit')
		}
		window.scrollTo(0, 0);
	}

	const columns = [
		{
			title: intl.get("Course.Name of course"),
			key: 'courseName',
			dataIndex: 'courseName',
			width: 260,
		},
		{
			title: intl.get("Course.Teacher"),
			key: 'teacherName',
			dataIndex: 'teacherName',
			width: 80,
		},
		{
			title: intl.get("Course.School hours"),
			key: 'courseAvailableTime',
			dataIndex: 'courseAvailableTime',
			width: 170,
		},
		{
			title: intl.get("Operation"),
			key: 'opreation',
			width: 200,
			render: (text, record) => {
				return <div className={styles.btnBox}>
					<Button style={{ marginRight: 10 }} onClick={() => linkTo(record.courseUuid)} size="small">{intl.get("Edit")}</Button>
					<Popconfirm
						title={intl.get("Delete")}
						description={intl.get("Are you sure to perform this operation")}
						onConfirm={() => deleteRecord(record.courseUuid)}
						okText={intl.get("Yes")}
						cancelText={intl.get("No")}
					>
						<Button type="primary" size="small">{intl.get("Delete")}</Button>
					</Popconfirm>
				</div>
			},
		},
	];
	return <div className={classnames('container', styles.myCourseBox)}>
		<h2>{intl.get("User.My courses")}</h2>
		<div>

			<div className={classnames('flex_box', 'flex_between', styles.queryBox)}>
				<Space.Compact style={{ width: '100%' }}>
					<Input
						allowClear
						style={{ width: 500 }}
						placeholder={intl.get("Course.Title Of Course")}
						onKeyDown={handleKeyDown}
						onChange={(e) => {
							setKeywords(e.target.value)
						}} />
					<Button type="primary" onClick={() => {
						setParams({
							...params,
							currentPage: 1
						})
					}}>{intl.get("Search")}</Button>
				</Space.Compact>
				<Button type="primary" onClick={() => linkTo()}>{intl.get("Add")}</Button>
			</div>

			<Table size="small" rowKey={record => record.courseUuid} pagination={false} columns={columns} dataSource={data} />

			<Pagination
				style={{ marginTop: "20px" }}
				align="end"
				current={params.currentPage}
				pageSize={params.pageSize}
				total={total}
				showSizeChanger={false}
				onChange={(page, pageSize) => {
					setParams({
						currentPage: page,
						pageSize: pageSize,
					});
				}}
			/>
		</div>
	</div>
}
export default MyCourse;